<template>
  <b-container v-if="verified">
    <Loading v-if="isLoading" :active.sync="isLoading"></Loading>
    <b-card class="page-body" body-class="has-footer">
      <CRow>
        <CCol xm="12" class="d-flex justify-content-center mb-4">
          <img class="header-img" src="../../assets/images/logo-evision.png">
        </CCol>
      </CRow>
      <CRow>
        <CCol xm="12" class="d-flex justify-content-center my-2">
          <h1 class="page-greetings">
            Facial Comparison
          </h1>
        </CCol>
      </CRow>
      <div class="content">
        <CRow>
          <CCol class="col-12 col-md-6 media-container-ekyc">
            <div class="media-wrapper-ekyc">
              <img :src="uploadedPhotoPreview">
            </div>
            <div class="form-button-ekyc">
              <router-link :to="{}" @click.native="onClickUploadPhoto" class="btn">
                <span><img src=""></span>Upload Photo
              </router-link>
            </div>
          </CCol>
          <CCol class="col-12 col-md-6 media-container-ekyc">
            <div class="media-wrapper-ekyc">
              <img v-show="webcamPhoto != null" :src="webcamPhotoPreview">
              <video ref="video" v-show="webcamPhoto == null" id="video" autoplay>Webcam not available.</video>
              <canvas id="canvas" ref="canvas" v-show="false" width="500" height="400"></canvas>
            </div>
            <div class="form-button-ekyc">
              <router-link v-if="webcamPhoto == null" :to="{}" @click.native="onClickWebcam" class="btn" :class="(uploadedPhoto != null && isWebcamReady) ? '' : 'disabled'">
                <span><img src=""></span>Take Webcam Photo
              </router-link>
              <router-link v-else :to="{}" @click.native="onClickRetake" class="btn danger">
                <span><img src=""></span>Discard and Take New Photo
              </router-link>
            </div>
          </CCol>
        </CRow>
        <CRow v-if="uploadedPhoto != null && webcamPhoto != null">
          <CCol col="12" class="item-footer mt-4">
            <div class="sm-nav-wrapper">
              <div class="bottom-router">
                <router-link :to="{}" @click.native="onClickSubmit(true)" class="btn custom fif-blue-1 rightside">
                  <span><img src=""></span>Submit (Mask)
                </router-link>
                <router-link :to="{}" @click.native="onClickSubmit(false)" class="btn custom fif-blue-1 rightside">
                  <span><img src=""></span>Submit
                </router-link>
              </div>
            </div>
          </CCol>
        </CRow>
      </div>
      <input style="height:0; border: 0; opacity: 0; filter:alpha(opacity=0);" ref="fileupload" type="file" @change="onUploadImage" accept="image/png, image/jpeg">
      <CRow v-if="results.length > 0">
        <CCol xm="12" class="d-flex justify-content-center my-2">
          <h4 class="greetings-underline">
            RESULTS
          </h4>
        </CCol>
      </CRow>
      <div v-if="results.length > 0" class="content">
        <CRow>
          <div class="col-12">
            <b-table small
              :fields="fields"
              :items="results"
            >
              <template #cell(index)="row">
                {{ row.index + 1 }}
              </template>
            </b-table>
          </div>
        </CRow>
      </div>
      <!-- <Modal v-if="showOfficeModal" :isList="true" :closeButton="false">
        <div slot="header">
          <label>Pilih Office</label>
        </div>
        <div slot="body">
          <div class="grid-kontrak list-kontrak">
            <div v-for="(office, index) in officeOptions"
              :key="'list-office-' + index"
              class="grid-item"
              role="navigation"
              @click="onClickOffice(office)"
            >
              <div class="item-header sm">
                <img src="../../assets/images/file.svg"> {{office.name}}
              </div>
            </div>
          </div>
        </div>
        <div slot="footer">
          <div class="btn-footer">
            <button class="btn-submit white" @click="showOfficeModal = false">
              Batal
            </button>
          </div>
        </div>
      </Modal>
      <Modal v-if="showDaytimeModal" :isList="true" :closeButton="false">
        <div slot="header">
          <label>Pilih Tanggal Booking</label>
        </div>
        <div slot="body">
          <div class="grid-kontrak list-kontrak">
            <div v-for="(daytime, index) in daytimeOptions"
              :key="'list-daytime-' + index"
              class="grid-item"
              role="navigation"
              @click="onClickDaytime(daytime)"
            >
              <div class="item-header sm">
                <img src="../../assets/images/file.svg"> {{daytime.dateDisplay}}
              </div>
            </div>
          </div>
        </div>
        <div slot="footer">
          <div class="btn-footer">
            <button class="btn-submit white" @click="showDaytimeModal = false">
              Batal
            </button>
          </div>
        </div>
      </Modal>
      <Modal v-if="showClocktimeModal" :isList="true" :closeButton="false">
        <div slot="header">
          <label>Pilih Jam Booking</label>
        </div>
        <div slot="body">
          <div class="grid-kontrak list-kontrak">
            <div v-for="(clocktime, index) in clocktimeOptions"
              :key="'list-clocktime-' + index"
              class="grid-item"
              role="navigation"
              @click="onClickClocktime(clocktime)"
            >
              <div class="item-header sm">
                <img src="../../assets/images/file.svg"> {{clocktime.startTime + ' - ' + clocktime.endTime}}
              </div>
            </div>
          </div>
        </div>
        <div slot="footer">
          <div class="btn-footer">
            <button class="btn-submit white" @click="showClocktimeModal = false">
              Batal
            </button>
          </div>
        </div>
      </Modal> -->
      <TheFooter></TheFooter>
    </b-card>
      <Modal v-if="showErrorModal" :foreground="true" :closeButton="false">
        <div slot="body">
          <label>{{errorLabel}}</label>
          <div class="btn-footer">
            <button class="btn-submit white" @click="showErrorModal = false">
              Tutup
            </button>
            <!-- <button v-if="errorReload" class="btn-submit white" @click="onClickBack">
              Kembali
            </button>
            <button v-else class="btn-submit white" @click="showErrorModal = false">
              Tutup
            </button>
            <button v-if="errorReload" class="btn-submit" @click="onClickReload">
              Muat Ulang
            </button>
            <button v-else class="btn-submit" @click="onClickBack">
              Kembali
            </button>
            <button v-else class="btn-submit" @click="onClickMenu">
              Menu Utama
            </button> -->
          </div>
        </div>
      </Modal>
  </b-container>
</template>
<script>
import TheFooter from  '../TheFooter';
import Modal from  '../Modal';
import moment from 'moment';

export default {
  name: 'Main',
  components: {
    TheFooter,
    Modal
  },
  data(){
    return {
      verified: false,
      isLoading: false,
      showErrorModal: false,
      // showOfficeModal: false,
      // showDaytimeModal: false,
      // showClocktimeModal: false,
      errorLabel: "Terjadi kesalahan pada server. Silahkan coba lagi.",
      errorReload: false,
      inputText: "",
      fields: [
          { key: 'index', label: '' },
          { key: 'category', label: 'Kategori' },
          { key: 'result', label: 'Hasil' },
      ],
      results: [],
      categoryMap: [],
      // serviceId: "",
      // serviceName: "",
      // customerId: "",
      // contractNo: "",
      // servOfficeCode: "",
      // workDayBook: 1,
      // officeOptions: [],
      // daytimeOptions: [],
      // clocktimeOptions: [],
      // selectedOffice: {},
      // selectedDaytime: {},
      // selectedClocktime: {}
      isWebcamReady: false,
      webcamPhoto: null,
      webcamPhotoPreview: require("../../assets/images/profile-blank.webp"),
      webcamPhotoBase64: "",
      uploadedPhoto: null,
      uploadedPhotoPreview: require("../../assets/images/profile-blank.webp"),
      uploadedPhotoBase64: ""
    }
  },
  async mounted() {
    // this.$axios.defaults.headers.post['Content-Type'] = 'application/json';
    // this.$axios.post(processUrl, data, { headers: {"Content-Type": "multipart/form-data"} }).then((response) => {
    let res = ""
    if(this.$cookies.get("api-key-ekyc")){
      res = this.$cookies.get("api-key-ekyc")
      this.verified = true
    }
    else{
      while(!res) res = window.prompt("Please enter your access key.", "")
      while(!this.verified){
        await this.$axios.post("https://validation.demo.inergi.id/api/auth/validate-key", null, { headers: {"API-Key": res} }).then(_ => {
          this.$cookies.set("api-key-ekyc", res)
          this.$axios.defaults.headers.post['API-Key'] = res
          this.$axios.defaults.headers.get['API-Key'] = res
          this.verified = true
        })
        .catch(error => {
          if(error.response){
            if(error.response.status == "401"){
              res = ""
              while(!res) res = window.prompt("Key validation failed. Please enter your access key.", "")
            }
            else{
              res = ""
              while(!res) res = window.prompt("Network error during verification. Please enter your access key.", "")
            }
          }
          else{
            res = ""
            while(!res) res = window.prompt("Network error during verification. Please enter your access key.", "")
          }
        })
      }
    }
    this.isLoading = true

    // quick workaround so the video component can load first
    await new Promise(r => setTimeout(r, 200));

    let video = document.getElementById("video")

    navigator.mediaDevices
      .getUserMedia({
        audio: false,
        video: { width: 500, height: 400 },
      })
      .then((stream) => {
        video.srcObject = stream
        this.isWebcamReady = true
      })
      .finally(() => {
        this.isLoading = false
      })
  },
  methods: {

    onClickUploadPhoto() {
      this.$refs.fileupload.click()
    },
    onUploadImage(e) {
        var files = e.target.files || e.dataTransfer.files
        this.uploadedPhoto = files[0]
        this.uploadedPhotoPreview = URL.createObjectURL(files[0])
        var reader = new FileReader()
        reader.readAsDataURL(this.uploadedPhoto)
        let vm = this
        reader.onload = function () {
          vm.uploadedPhotoBase64 = reader.result
        }
        // if(!files.length) return
        // else if(files[0].size > this.$uploadLimit) {
        //     return
        // }
        // for(let i = 0; i < files.length; i++){
        //     let fileMedia = ''
        //     let fileAltText = ''
        //     if(files[i].type == 'image/jpeg' || files[i].type == 'image/png') {
        //         fileMedia = 'image'
        //         fileAltText = 'Upload Image Preview'
        //     }
        //     else if(files[i].type == 'video/mp4' || files[i].type == 'video/webm' || files[i].type == 'video/ogg'){
        //         fileMedia = 'video'
        //         fileAltText = 'Upload Video Preview'
        //     }
        //     else {
        //         this.$helper.toastError(this, "Upload Item Gagal! Jenis file " + files[i].name + " tidak dikenali oleh sistem.")
        //         continue
        //     }
        //     let filenameSplit = files[i].name.split('.')
        //     let fileExtension = filenameSplit.pop()
        //     let filename = filenameSplit.join()
        //     let fileResult = {
        //         id: null,
        //         media: fileMedia,
        //         type: files[i].type,
        //         filename: filename,
        //         extension: fileExtension,
        //         url: URL.createObjectURL(files[i]),
        //         altText: fileAltText,
        //         status: 'upload',
        //         isActive: false,
        //         file: files[i]
        //     }
        //     this.mediaList.push(fileResult)
        //     // for(let i = 0; i < this.mediaList.length; i++){
        //     //     this.mediaList[i].isActive = false
        //     // }
        //     // this.mediaPreview = lodash.cloneDeep(fileResult)
        //     this.isImageChanged = true
        //     this.$helper.toastSuccess(this, "Upload " + files[i].name + " berhasil!")
        // }
        this.$refs.fileupload.value = null
    },
    // async getOffices(){
    //   this.isLoading = true
    //   let processUrl = "/office/get-office-iss-enabled?exist=1"
    //   await this.$axios.get(processUrl).then((response) => {
    //     if (response.status === 200){
    //       this.officeOptions = response.data
    //       this.selectedOffice = {}
    //     }
    //     else {
    //       this.errorLabel = "Terjadi kesalahan pada server. Silahkan coba lagi."
    //       this.errorReload = true
    //       this.showErrorModal = true
    //     }
    //   })
    //   .catch(_ => {
    //     this.errorLabel = "Terjadi kesalahan pada server. Silahkan coba lagi."
    //     this.errorReload = true
    //     this.showErrorModal = true
    //   })
    //   .finally(() => {
    //     this.isLoading = false
    //   })
    // },
    // onFocusOffice(){
    //   this.showOfficeModal = true
    // },
    // onFocusDaytime(){
    //   this.showDaytimeModal = true
    // },
    // onFocusClocktime(){
    //   this.showClocktimeModal = true
    // },
    // onClickOffice(office){
    //   this.selectedOffice = office
    //   this.isLoading = true
    //   let processUrl = "/fmc/getDayTimeFrame"
    //   processUrl += "?servOfficeCode=" + this.selectedOffice.servOfficeCode
    //   processUrl += "&bookingDate=" + moment().add(this.workDayBook, 'day').format("YYYY-MM-DD")
    //   processUrl += "&serviceId=" + this.serviceId
    //   this.$axios.get(processUrl).then((response) => {
    //     if (response.status === 200){
    //       this.daytimeOptions = response.data.data.filter(item => item.available)
    //       this.daytimeOptions = this.daytimeOptions.map(item => {
    //         let split = item.date.split("-")
    //         let newDate = split[2] + "-" + split[1] + "-" + split[0]
    //         item.dateDisplay = moment(newDate).locale("id").format("dddd, D MMMM YYYY")
    //         return item
    //       })
    //       this.selectedDaytime = {}
    //       this.showOfficeModal = false
    //     }
    //     else {
    //       this.errorLabel = "Terjadi kesalahan pada server. Silahkan coba lagi."
    //       this.errorReload = true
    //       this.showErrorModal = true
    //     }
    //   })
    //   .catch(_ => {
    //     this.errorLabel = "Terjadi kesalahan pada server. Silahkan coba lagi."
    //     this.errorReload = true
    //     this.showErrorModal = true
    //   })
    //   .finally(() => {
    //     this.isLoading = false
    //   })
    // },
    // onClickDaytime(daytime){
    //   this.selectedDaytime = daytime
    //   let dateSplit = this.selectedDaytime.date.split("-")
    //   this.selectedDaytime.dateFlip = dateSplit[2] + '-' + dateSplit[1] + '-' + dateSplit[0]
    //   this.isLoading = true
    //   let processUrl = "/fmc/getClockTimeFrame"
    //   processUrl += "?servOfficeCode=" + this.selectedOffice.servOfficeCode
    //   processUrl += "&bookingDate=" + this.selectedDaytime.dateFlip
    //   processUrl += "&serviceId=" + this.serviceId
    //   this.$axios.get(processUrl).then((response) => {
    //     if (response.status === 200){
    //       this.clocktimeOptions = response.data.data.timeFrame.filter(item => item.slot > 0)
    //       this.selectedClocktime = {}
    //       this.showDaytimeModal = false
    //     }
    //     else {
    //       this.errorLabel = "Terjadi kesalahan pada server. Silahkan coba lagi."
    //       this.errorReload = false
    //       this.showErrorModal = true
    //     }
    //   })
    //   .catch(_ => {
    //     this.errorLabel = "Terjadi kesalahan pada server. Silahkan coba lagi."
    //     this.errorReload = false
    //     this.showErrorModal = true
    //   })
    //   .finally(() => {
    //     this.isLoading = false
    //   })
    // },
    // onClickClocktime(clocktime){
    //   this.selectedClocktime = clocktime
    //   this.selectedClocktime.display = clocktime.startTime + ' - ' + clocktime.endTime
    //   this.showClocktimeModal = false
    // },
    // onClickBack(){
    //   this.$store.commit('set', ['contractNo', ""])
    //   this.$store.commit('set', ['servOfficeCode', ""])
    //   this.$store.commit('set', ['workDayBook', ""])
    //   // this.$router.push({ name: "Kontrak" })
    //   this.$router.push({ name: "KontrakBypass" })
    // },
    // onClickMenu(){
    //   this.$store.commit('set', ['serviceId', ""])
    //   this.$store.commit('set', ['serviceName', ""])
    //   this.$store.commit('set', ['customerId', ""])
    //   this.$store.commit('set', ['contractList', ""])
    //   this.$store.commit('set', ['contractNo', ""])
    //   this.$store.commit('set', ['servOfficeCode', ""])
    //   this.$store.commit('set', ['workDayBook', ""])
    //   this.$router.push({ name: "Menu" })
    // },
    // async onClickReload(){
    //   await this.getOffices()
    //   for(let i = 0; i < this.officeOptions.length; i++){
    //     if(this.officeOptions[i].servOfficeCode == this.servOfficeCode){
    //       this.selectedOffice = this.officeOptions[i]
    //       this.onClickOffice(this.officeOptions[i])
    //       break
    //     }
    //   }
    // },
    onClickWebcam(){

      const context = this.$refs.canvas.getContext('2d');
      context.drawImage(this.$refs.video, 0, 0, 500, 400);

      document.getElementById("canvas").toBlob((blob) => {
        let file = new File([blob], "webcam-preview.jpg", { type: "image/jpeg" })
        this.webcamPhotoPreview = URL.createObjectURL(file)
        this.webcamPhoto = file
        var reader = new FileReader()
        reader.readAsDataURL(this.webcamPhoto)
        let vm = this
        reader.onload = function () {
          vm.webcamPhotoBase64 = reader.result
        }
      }, 'image/jpeg');

      // var byteString;
      // if (img.split(',')[0].indexOf('base64') >= 0)
      //     byteString = atob(img.split(',')[1]);
      // else
      //     byteString = unescape(img.split(',')[1]);
      // // separate out the mime component
      // var mimeString = img.split(',')[0].split(':')[1].split(';')[0];
      // // write the bytes of the string to a typed array
      // var ia = new Uint8Array(byteString.length);
      // for (var i = 0; i < byteString.length; i++) {
      //     ia[i] = byteString.charCodeAt(i);
      // }
      // var file = new Blob([ia], {type:mimeString});

      // this.isLoading = true
      // let processUrl = "/backend/ner"
      // let data = {
      //   text: this.inputText
      // }
      // // let data = new FormData()
      // // data.set('officeCode', this.selectedOffice.officeCode)
      // this.$axios.post(processUrl, data).then((response) => {
      //   if (response.status === 200){
      //     let raw = response.data.data
      //     let entries = []
      //     let isNewWord = false
      //     let currCategory = ""
      //     let currCount = 0
      //     let currWord = ""
      //     let currTotalScore = 0
      //     for(let i = 0; i < raw.length; i++){
      //       let [prefix, category] = raw[i].entity.split("-")
      //       // if B-prefix, start new word
      //       if(prefix === "B"){
      //         isNewWord = true
      //       }
      //       else{
      //         // if I-prefix, but differing category, start new word
      //         if(currCategory !== "" && category !== currCategory){
      //           isNewWord = true
      //         }
      //         // if I-prefix and same category, continue previous word
      //         else{
      //           isNewWord = false
      //         }
      //       }
      //       // if new word and there is a previous word, push and reset tally
      //       if(isNewWord && currCount > 0){
      //         currWord = currWord.replace(/▁/g," ").trim()
      //         entries.push({ word:currWord, category:this.categoryMap[currCategory], score:parseFloat(currTotalScore / currCount) })
      //         currCategory = ""
      //         currCount = 0
      //         currWord = ""
      //         currTotalScore = 0
      //       }
      //       // start tally
      //       currCategory = category
      //       currCount += 1
      //       currWord += raw[i].word
      //       currTotalScore += parseFloat(raw[i].score)
      //     }
      //     // push the last keyword
      //     currWord = currWord.replace(/▁/g," ").trim()
      //     entries.push({ word:currWord, category:this.categoryMap[currCategory], score:parseFloat(currTotalScore / currCount) })
      //     this.keywords = entries
      //   }
      //   else {
      //     this.errorLabel = "Terjadi kesalahan pada server. Silahkan coba lagi."
      //     this.errorReload = false
      //     this.showErrorModal = true
      //     return
      //   }
      // })
      // .catch(error => {
      //   if(error.response) this.errorLabel = error.response.data.reason
      //   else this.errorLabel = "Terjadi kesalahan pada server. Silahkan coba lagi."
      //   this.errorReload = false
      //   this.showErrorModal = true
      // })
      // .finally(() => {
      //   this.isLoading = false
      // })
    },
    onClickRetake(){
      this.webcamPhoto = null
      this.webcamPhotoPreview = require("../../assets/images/profile-blank.webp")
    },
    onClickSubmit(isMask = false){

      this.isLoading = true
      // let processUrl = "/face_recognition"
      let processUrl = "https://validation.demo.inergi.id/api/api-ekyc/face_recognition"

      let payload = {
        face_1: this.uploadedPhotoBase64.split(",")[1],
        face_2: this.webcamPhotoBase64.split(",")[1],
        key: "4aa15da1af974b22a39dfac1f9e414f0",
        detect_mask: isMask
      }
      
      this.$axios.post(processUrl, payload).then((response) => {
        if (response.status === 200 && response.data.success){
          this.results = []
          this.results.push({ category: "ID", result: response.data.id })
          this.results.push({ category: "Confidence", result: response.data.data.confidence })
          this.results.push({ category: "Distance", result: response.data.data.distance })
        }
        else {
          if(response.data.message) this.errorLabel = response.data.message
          else this.errorLabel = "Terjadi kesalahan pada server. Silahkan coba lagi."
          this.errorReload = true
          this.showErrorModal = true
        }
      })
      .catch(error => {
        if(error.response){
          if(error.response.status == "401"){
            this.errorLabel = "API Key tidak valid atau sudah tidak berlaku. Mohon menghubungi tim untuk kode akses baru."
            this.$cookies.remove("api-key-ekyc")
            delete this.$axios.defaults.headers.post['API-Key']
          }
          else{
            if(error.response.data && error.response.data.reason) this.errorLabel = error.response.data.reason
            else this.errorLabel = "Terjadi kesalahan pada server. Silahkan coba lagi."
          }
        }
        else this.errorLabel = "Terjadi kesalahan pada server. Silahkan coba lagi."
        this.errorReload = false
        this.showErrorModal = true
      })
      .finally(() => {
        this.isLoading = false
      })
    }
  },
}
</script>